export const SET_STATUS_TRACKER_DATA = 'SET_STATUS_TRACKER_DATA';



// WEBPACK FOOTER //
// ./src/store/reducers/statusTracker/actionTypes.js